import React from 'react';

import { IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';

import { bool, func, string, number, node, oneOf } from 'prop-types';

import { SnackBarStyled } from './styles';

const SnackBar = ({ open, onClose, message, color, autoHideDuration, vertical, horizontal, type, action }) => (
  <SnackBarStyled
    open={open}
    color={color}
    key={message}
    onClose={onClose}
    autoHideDuration={autoHideDuration}
    anchorOrigin={{
      vertical,
      horizontal,
    }}
  >
    <Alert
      variant="filled"
      severity={type}
      onClose={onClose}
      action={[
        action,
        <IconButton key="close" aria-label="Fechar mensagem" color="inherit" onClick={onClose}>
          <Close />
        </IconButton>,
      ]}
    >
      {message}
    </Alert>
  </SnackBarStyled>
);

SnackBar.propTypes = {
  open: bool,
  action: node,
  onClose: func,
  message: string,
  color: string,
  autoHideDuration: number,
  horizontal: oneOf(['left', 'center', 'right']),
  vertical: oneOf(['top', 'bottom']),
  type: oneOf(['error', 'warning', 'info', 'success']),
};

SnackBar.defaultProps = {
  autoHideDuration: 5000,
  horizontal: 'center',
  vertical: 'top',
  type: 'error',
};

export default SnackBar;
